import { useEffect, useState } from "react";
import { toast } from "sonner";
import { api, fmtDate } from "@/lib/api";
import { PageHeader, StatCard } from "@/components/shared";
import { Button } from "@/components/ui/button";

export default function AdminWatcher() {
  const [h, setH] = useState(null);
  const load = () => api.get("/admin/watcher").then((r) => setH(r.data));
  useEffect(() => { load(); const t = setInterval(load, 15000); return () => clearInterval(t); }, []);
  const run = async () => { await api.post("/admin/watcher/run"); toast.success("Cycle watcher exécuté"); load(); };

  return (
    <div>
      <PageHeader title="Santé du watcher" subtitle="Surveillance des adresses en attente via mempool.space (abstraction remplaçable par un nœud Bitcoin Core ou Electrum).">
        <Button variant="secondary" onClick={run} data-testid="watcher-run-now-btn">Exécuter un cycle maintenant</Button>
      </PageHeader>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 sm:gap-6 mb-6">
        <StatCard label="État" value={h ? (h.watcher.last_error ? "Erreur" : "OK") : "—"} hint={h ? `dernier cycle ${fmtDate(h.watcher.last_run)}` : ""} testId="watcher-health-card" accent={h?.watcher.last_error ? "text-red-400" : "text-emerald-400"} />
        <StatCard label="Commandes surveillées" value={h?.watching ?? "—"} testId="watcher-watching" />
        <StatCard label="Cycles / vérifs" value={h ? `${h.watcher.runs} / ${h.watcher.orders_checked}` : "—"} testId="watcher-runs" />
        <StatCard label="Taux BTC" value={h ? `${h.rates.EUR?.toLocaleString("fr-FR")} €` : "—"} hint={h ? `${h.rates.USD?.toLocaleString("en-US")} $` : ""} testId="watcher-rates" accent="text-amber-400" />
      </div>
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        {h && Object.entries(h.sources).map(([net, s]) => (
          <div key={net} className="panel p-5" data-testid={`source-${net}`}>
            <div className="flex items-center justify-between mb-3"><span className="font-heading font-semibold capitalize">{net}</span><span className={`h-2.5 w-2.5 rounded-full ${s.ok ? "bg-emerald-500" : "bg-red-500"}`} /></div>
            <div className="text-sm space-y-1">
              <div className="flex justify-between"><span className="text-zinc-500">Hauteur de bloc</span><span className="font-mono" data-testid="bitcoin-node-height-value">{s.height ?? "—"}</span></div>
              <div className="flex justify-between"><span className="text-zinc-500">Latence</span><span className="font-mono">{s.latency_ms ?? "—"} ms</span></div>
              <div className="flex justify-between"><span className="text-zinc-500">Source</span><span className="font-mono text-xs">{s.source}</span></div>
              {s.error && <div className="text-red-400 text-xs">{s.error}</div>}
            </div>
          </div>
        ))}
      </div>
      {h?.watcher.last_error && <div className="panel p-4 mt-6 border-red-500/40 text-sm text-red-400">{h.watcher.last_error}</div>}
    </div>
  );
}
